import styled from "@emotion/styled";
import { units } from "../../../../types/units";
import { makeStyles, Theme } from "@material-ui/core";

export const NoticeBarWrapper = styled.div`
  border-radius: 3px;
  display: block;
  padding: 5px 10px;
  margin: 1rem 0;
  text-align: center;
  ${units({
    backgroundColor: "yellow",
  })};
`;
export const useStylesToolTip = makeStyles((theme: Theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
}));
